const getVideoPlayer = (player) => ({
    player,
    isPlaying: () => player.currentTime > 0 && !player.paused && !player.ended && player.readyState > 2,
    getCurrentTime: () => player.currentTime || 0,
    getVideoDuration: () => player.duration || 0,
    attachEvents: (listeners) => {
        const pagehideHandler = (event) => {
            if (!event.persisted) {
                listeners.pagehide();
            }
        };
        const errorHandler = () => {
            listeners.error(player.error);
        };
        Object.keys(listeners).forEach((event) => {
            switch (event) {
                case 'visibilitychange':
                    document.addEventListener(event, listeners[event], false);
                    break;
                case 'pagehide':
                    window.addEventListener(event, pagehideHandler, false);
                    break;
                case 'error':
                    player.addEventListener(event, errorHandler, false);
                    break;
                default:
                    player.addEventListener(event, listeners[event], false);
                    break;
            }
        });
        return () => {
            Object.keys(listeners).forEach((event) => {
                switch (event) {
                    case 'visibilitychange':
                        document.removeEventListener(event, listeners[event], false);
                        break;
                    case 'pagehide':
                        window.removeEventListener(event, pagehideHandler, false);
                        break;
                    case 'error':
                        player.removeEventListener(event, errorHandler, false);
                        break;
                    default:
                        player.removeEventListener(event, listeners[event], false);
                        break;
                }
            });
        };
    },
});
export default getVideoPlayer;
